import { routerMiddleware } from 'react-router-redux'
import { createBrowserHistory as createHistory } from 'history'

export const history = createHistory()

export default routerMiddleware(history)
